/**************************************************
 * Nombre:       Educacion_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/Temporales/fondo_home_portada.png'
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import linea from "../../../Recursos/Iconos/ic_raya.svg";

const Educacion_Portada = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'linear-gradient(180deg, rgba(48, 51, 118, 0.94) 0%, rgba(48, 51, 118, 0.76) 100%),  url(' + fondo + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                pt: 15,
                mt: -18,
                pb: 30
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: '#fff', mt: 4}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: sCell ? 24 : 32,
                                    fontWeight: 400,
                                    lineHeight: 1.1,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>
                                <img src={linea} width={40} height={'auto'} alt={'linea'}
                                     style={{marginTop: -7, marginBottom: 7, paddingRight: 8}}/>
                             OFERTA EDUCATIVA
                                <img src={linea} width={40} height={'auto'} alt={'linea'}
                                     style={{marginTop: -7, marginBottom: 7, paddingLeft: 8}}/>
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography
                                sx={{fontSize: sCell ? 16 : 18, fontWeight: 300, lineHeight: sCell ? 1.3 : 1.3, textAlign: 'center'}}>
                            Todas nuestras ofertas educativas cuentan con la resolución de funcionamiento respectivo
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Educacion_Portada

const anuncios = [1]